<template>
  <div class="rentStyle">
    <van-cell-group>
      <div class="user">
        <p>
          {{ userInfo.Name }} <span>{{ userInfo.Mobile }}</span>
        </p>
      </div>
      <!--@click.native="changeAddress" @click="addrVisible = true" is-link-->
      <van-cell
          required
          icon="location-o"
          :title="userInfo.FullAddress ? userInfo.FullAddress : '请选择地址'"
          class="FullAddress"
      />
    </van-cell-group>
    <template v-if="!validOrderLoading">
      <template v-if="isValidOrder">
        <div style="height: 100px;text-align: center;line-height: 100px">{{isValidOrder}}，<span style="color: #00b3f3;" @click="linkTo">去换寝</span></div>
      </template>
      <template v-else>
        <van-cell-group>
          <van-cell
              title="租赁套餐："
              is-link
              :value="actions.length > 0 ? PackageItem.name : '暂无可选择租赁套餐'"
              @click.native="changePackage"
          />
        </van-cell-group>
        <equipment-detail
            v-if="PackageItem.Id"
            :details="Object.assign(PackageItem, { Name: PackageItem.FullName })"
            :FullName="false"
        ></equipment-detail>


        <!--   members     -->
        <dormitory-staff v-if="userInfo.Id" @data="getDormitoryStaff" show-balance></dormitory-staff>

<!--        <div class="members">-->
<!--          <h4 style="margin: 0">添加成员</h4>-->
<!--          <p style="font-size: 12px; color: #999; padding: 0 10px">-->
<!--            *请完善填写全部学生信息，否则可能会影响他人权益！-->
<!--          </p>-->
<!--          <van-row>-->
<!--            <div-->
<!--                v-for="(item, index) in memberList"-->
<!--                :key="index"-->
<!--                style="-->
<!--            border-bottom: 1px solid #ebedf0;-->
<!--            overflow: hidden;-->
<!--            margin-bottom: 2px;-->
<!--          "-->
<!--            >-->
<!--              <van-col span="21">-->
<!--                <van-col :span="index === 0 ? '16' : '15'">-->
<!--                  <van-field-->
<!--                      v-model="item.Mobile"-->
<!--                      type="text"-->
<!--                      placeholder="手机号"-->
<!--                      @blur="mobileChange(item, index)"-->
<!--                      @change="getMember(item, index)"-->
<!--                      :error-message="item.mobileMessage"-->
<!--                      v-scrolltop-->
<!--                  />-->
<!--                </van-col>-->
<!--                <van-col span="8">-->
<!--                  <van-field-->
<!--                      v-model="item.Name"-->
<!--                      type="text"-->
<!--                      placeholder="成员姓名"-->
<!--                      v-scrolltop-->
<!--                  />-->
<!--                </van-col>-->
<!--                <van-col span="24" style="margin-bottom: 10px;padding-left: 20px">余额：{{item.Balance}}</van-col>-->
<!--              </van-col>-->
<!--              <van-col span="3" v-if="index !== 0" style="height: 87px">-->
<!--                <van-button-->
<!--                    type="danger"-->
<!--                    style="width: 100%; padding: 0; height: 100%"-->
<!--                    @click="deleteMember(index)"-->
<!--                >-->
<!--                  <van-icon name="delete"-->
<!--                  />-->
<!--                </van-button>-->
<!--              </van-col>-->
<!--            </div>-->
<!--            <van-col span="24" style="margin-top: 10px">-->
<!--              <van-button-->
<!--                  round-->
<!--                  type="primary"-->
<!--                  size="small"-->
<!--                  icon="star-o"-->
<!--                  @click="addMember"-->
<!--                  style="width: 100%"-->
<!--              >新增成员-->
<!--              </van-button-->
<!--              >-->
<!--            </van-col>-->
<!--          </van-row>-->
<!--        </div>-->
        <van-popup
            v-model="addMemberVisible"
            style="width: 70%"
            v-if="addMemberVisible"
        >
          <van-field
              :value="memberList[memberIndex].Mobile"
              label="手机号："
              label-width="90"
          />
          <van-field
              v-model="memberList[memberIndex].Name"
              label="姓名"
              label-width="90"
              placeholder="请输入成员姓名"
              required
              clearable
          />
          <div class="footer-btn">
        <span>
          <van-button size="small" @click="cancelAdd">取消</van-button>
          <van-button
              size="small"
              type="primary"
              :disabled="!memberList[memberIndex].Name"
              @click="rule"
          >提交</van-button
          >
        </span>
          </div>
        </van-popup>
        <div>
          <p style="padding-left: 10px">备注内容：</p>
          <van-field
              v-model="Remarks"
              type="textarea"
              placeholder="请输入备注"
              style="height: 50%"
              v-scrolltop
          />
        </div>
        <template v-if="PackageItem.Id && !$route.query.isPay">
          <p style="padding-left: 10px">支付方式：</p>
          <van-radio-group v-model="payType">
            <van-cell-group>
              <van-cell title="微信支付" clickable @click="payType = 'onLine'">
                <template slot="title">
                  <svg-icon slot="icon" icon-class="onLine" class-name="icon-onLine"></svg-icon>
                  微信支付
                </template>
                <van-radio name="onLine" checked-color="#00d8a0"></van-radio>
              </van-cell>
              <van-cell clickable @click="payType = 'offline'">
                <template slot="title">
                  <svg-icon slot="icon" icon-class="offline" class-name="icon-offline"></svg-icon>
                  线下支付
                </template>
                <van-radio name="offline" checked-color="#00d8a0"></van-radio>
              </van-cell>
              <van-cell title="余额支付" clickable @click="changePayType">
                <template slot="title">
                  <svg-icon slot="icon" icon-class="yuezf" class-name="icon-yuezf"></svg-icon>
                  &nbsp;余额支付
                </template>
                <van-radio name="yue" checked-color="#00d8a0" :disabled="!canBalancePay"></van-radio>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </template>
        <div
            style="
        position: fixed;
        display: flex;
        justify-content: center;
        margin: 0.4rem 0 0;
        bottom: 44px;
        z-index: 3;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        background: #f6f6f6;
        padding: 10px 0;
      "
            v-if="!IsRegister"
        >
          <div style="float: left; margin: -1px 5px 0">
            <van-radio-group v-model="radio" @change="changeRadio">
              <van-radio name="1" checked-color="rgb(0,216,160)"></van-radio>
            </van-radio-group>
          </div>
          <p @click.stop="Onchange" style="text-decoration: underline; margin: 0">
            我同意《思沃学生宿舍空调租赁协议》
          </p>
        </div>
        <van-popup
            v-model="show"
            style="width: 100%; height: 100%; padding: 50px 20px 20px 20px"
            get-container="body"
        >
          <p v-if="detailsLoading" style="text-align: center">加载中...</p>
          <template v-else>
            <van-row
                style="padding: 0.5rem; border: 1px solid black"
                v-if="ContractInfo">
              <p style="
              text-align: center;
              margin: 5px 0;
              font-size: 0.5rem;
              font-weight: bold;
            ">
                {{ ContractInfo.Title }}
              </p>
              <br/>
              <span style="white-space: pre-wrap" v-html="ContractInfo.Text"></span>
            </van-row>
            <van-col :span="24" style="text-align: center; margin-top: 10px">
              <van-button type="info" size="small" @click="alreadyRead">我已阅读</van-button>
            </van-col>
          </template>
          <div class="details-error" v-if="detailsError">
            <p v-if="!isReload">加载异常</p>
            <van-button
                type="info"
                size="small"
                @click="getContract(userInfo.RegionId, 'reload')"
            >{{ isReload ? "加载中...." : "重新加载" }}
            </van-button
            >
          </div>
        </van-popup>
        <wx-pay
            :params="{ Id: ParentOrderId }"
            ref="refWxPay"
            class="pay-footer"
            :control="payType === 'onLine'"
            @successPay="successPay">
          <div>
            合计：<span>￥{{ actualPay || 0}}</span>
          </div>
          <van-button
              type="info"
              size="normal"
              @click="subRent"
              :loading="subRentLoading"
              loading-text="加载中..."
          >提 交
          </van-button>
        </wx-pay>
      </template>
    </template>



    <van-popup
        v-model="select"
        position="bottom"
        style="width: 100%; height: 80%"
    >
      <div style="height: 100%; overflow-y: auto">
        <template v-for="(item, index) in RegionList">
          <van-cell @click="region(item, index)">
            <template slot="title">
              <span
              >{{ item.Name }}
                <span v-if="item.ExtendName"
                >（{{ item.ExtendName }}）</span
                ></span
              >
            </template>
          </van-cell>
        </template>
      </div>
    </van-popup>
    <van-action-sheet
        v-model="ShowPackage"
        :actions="actions"
        @select="onSelect"
    />
    <van-popup get-container="body" v-model="addrVisible" style="width: 100%;height: 100%" position="right">
      <change-addr v-if="addrVisible" @close="addrVisible = false" @changeAddr="getNewAddr" is-popup></change-addr>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import changeAddr from "@/views/user/changeAddr/index.vue";
import dormitoryStaff from "@/views/modules/dormitoryStaff.vue";
import { setWeixInfo } from "@/utils/auth";
import { setCookie } from "@/utils/cookie";

export default {
  name: "rent",
  data() {
    return {
      canBalancePay: true,
      addrVisible: false,
      addMemberVisible: false,
      memberIndex: "",
      isReload: false,
      detailsError: false,
      detailsLoading: true,
      subRentLoading: false,
      memberList: [],
      IsRegister: false,
      show: false,
      radio: "",
      payType: "onLine",
      orderId: "",
      ParentOrderId: '',
      Remarks: "",
      ContractInfo: {},
      packageDetails: {},
      actions: [],
      ShowPackage: false,
      userInfo: {},
      transitionName: "",
      RegionList: [],
      userAddress: [], // 储存地址
      select: false,
      RegionId: "",
      index: 0,
      PackageItem: {
        name: "请选择租赁套餐",
      }, // 套餐信息 {name,id}
      isRead: false,
      isValidOrder: '',
      validOrderLoading: true
    };
  },
  computed: {
    // price() {
    //   return (money, quantity) => {
    //     this.PackageItem.Price
    //   }
    // }
    // sumPrice() {
    //   return Number(
    //       this.memberList
    //           .map((i) => i.Price)
    //           .reduce((a, b) => Number(a) + Number(b))
    //   );
    // },
    // sumDeposit() {
    //   return Number(
    //       this.memberList
    //           .map((i) => i.Deposit)
    //           .reduce((a, b) => Number(a) + Number(b))
    //   );
    // },
    actualPay() {
      if (this.PackageItem.Id) {
        const sum = Number(this.PackageItem.Price) + Number(this.PackageItem.Deposit)
        const memberSum = Number(this.memberList.map((i) => i.Balance).reduce((a,b) => Number(a) + Number(b)))
        // return this.$route.query.isPay ? 0 : (sum - memberSum > 0 ? sum-memberSum : 0)
        return sum
      }
    },
  },
  methods: {
    getCanBalancePay() {
      if (this.PackageItem.Id && this.memberList.length) {
        // 押金
        const isEqualDeposit = this.memberList.every(el => el.BalanceDeposit === this.memberList[0].BalanceDeposit)
        // 租金
        const isEqualPrice = this.memberList.every(el => el.BalancePrice === this.memberList[0].BalancePrice)
        // 人员押金总和
        const memberSumDeposit = Number(this.memberList.map((i) => i.BalanceDeposit).reduce((a,b) => Number(a) + Number(b)))

        // 人员租金总和
        const memberSumPrice = Number(this.memberList.map((i) => i.BalancePrice).reduce((a,b) => Number(a) + Number(b)))

        // const sum = Number(this.PackageItem.Price) + Number(this.PackageItem.Deposit)
        // const memberSum = Number(this.memberList.map((i) => i.Balance).reduce((a,b) => Number(a) + Number(b)))
        this.canBalancePay = isEqualDeposit && isEqualPrice && !(memberSumDeposit - Number(this.PackageItem.Deposit) < 0) && !(memberSumPrice - Number(this.PackageItem.Price) < 0)
      }else {
        this.canBalancePay = false
      }
    },
    changePayType(){
      if (this.canBalancePay){
        this.payType = 'yue'
      }
    },
    getDormitoryStaff(data) {
      this.memberList = data
    },
    async getNewAddr(data) {
      const params = {
        DormitoryId: data[data.length -1].Id
      }
      const { Data } = await this.$post('/BizMemberParentOrder/ParentDetailsByDormitory', params)
      if (Data) {
        this.$toast.fail('该寝室下已有有效订单!')
      }
      if (data.isWarning){
      }
      this.$set(this.userInfo, 'FullAddress', this.getAddr(data))
      this.addrVisible = false
    },
    getAddr(data) {
      this.userAddress = data;
      let str = "";
      this.userAddress.forEach((item) => {
        str += item.Name + "-";
      });
       return str.substr(0, str.length - 1);
    },
    changeRadio() {
      if (this.radio === "1" && !this.isRead) {
        this.Onchange();
      }
    },
    getMember(item, index) {
      if (this.userInfo.Mobile === item.Mobile){
        item.Name = "";
        item.MemberId = "";
        this.memberIndex = index;
        this.$dialog
            .confirm({
              title: "提示",
              message: "不允许将自己作为成员",
              confirmButtonText: "确定",
              showCancelButton: false
            })
            .then(() => {
              item.Mobile = "";
              // on confirm
            }).catch(() => {
          // on cancel
        });
        return false
      }
      this.$post("/BizMemberMember/FindByMobileAndIsEffective", {
        mobile: item.Mobile,
      }).then((res) => {
        if (res.Status !== 1) {
          item.Mobile = ''
          item.Name = "";
          item.MemberId = "";
          return false
        }
        if (res.Data) {
          if(res.Data.DormitoryId === this.userInfo.DormitoryId) {
            item.Name = res.Data.Name;
            item.MemberId = res.Data.Id;
            item.Balance = res.Data.Balance
          }else {
            item.Name = "";
            item.MemberId = "";
            this.memberIndex = index;
            this.$dialog
                .confirm({
                  title: "提示",
                  message: "用户寝室号与当前寝室号不符，请更改寝室",
                  confirmButtonText: "确定",
                  showCancelButton: false
                })
                .then(() => {
                  item.Mobile = "";
                  // on confirm
                }).catch(() => {
                  // on cancel
                });
          }
          // this.isFind = true;
        } else {
          item.Name = "";
          item.MemberId = "";
          this.memberIndex = index;
          this.$dialog
              .confirm({
                title: "提示",
                message: "未查询到该用户，是否新增",
                confirmButtonText: "是",
                cancelButtonText: "否",
              })
              .then(() => {
                this.addMemberVisible = true;
                // on confirm
              })
              .catch(() => {
                item.Mobile = "";
                // on cancel
              });

          // this.isFind = false;
        }
      });
    },
    cancelAdd() {
      this.memberList[this.memberIndex].Mobile = "";
      this.memberList[this.memberIndex].Name = "";
      this.addMemberVisible = false;
      this.memberIndex = "";
    },
    rule() {
      const params = {
        Name: this.memberList[this.memberIndex].Name,
        Mobile: this.memberList[this.memberIndex].Mobile,
        DormitoryId: this.userInfo.DormitoryId,
      };
      this.$post("/BizMemberMember/Add", params).then((res) => {
        if (res.Data) {
          this.memberList[this.memberIndex].MemberId = res.Data.Id;
          this.memberList[this.memberIndex].Balance = res.Data.Balance;
          this.addMemberVisible = false;
          this.memberIndex = "";
        }
      });
    },
    mobileChange(item, index) {
      if (item.Mobile !== "") {
        let mobile = item.Mobile.replace(/\s*/g, "");
        if (!/^1[3456789]\d{9}$/.test(mobile)) {
          item.mobileMessage = "手机号码有误！";
        } else {
          item.mobileMessage = "";
        }
      }
    },
    Onchange() {
      this.show = !this.show;
    },
    alreadyRead() {
      this.radio = "1";
      this.isRead = true;
      this.Onchange();
    },
    addMember() {
      if (this.PackageItem.Id) {
        /**
         * 新增成员时，需要默认+1才是正确的所有成员数量
         */
        for (let i = 0; i < this.memberList.length; i++) {
          if (!this.memberList[i].Name) {
            this.$toast.fail("请完善成员名称！");
            return false;
          }
          if (!this.memberList[i].Mobile) {
            this.$toast.fail("请完善成员手机！");
            return false;
          } else {
          }
        }
        this.memberList.push({
          Name: "",
          Mobile: "",
          mobileMessage: "",
          Price: 0,
          PriceDecimals: 0,
          Deposit: 0,
          DepositDecimals: 0,
          MemberId: "",
          Balance: 0
        });
        this.calculate();
      } else {
        this.$toast("请先选择套餐！");
      }
    },
    calculate(memberNum, item) {
      const num = memberNum || this.memberList.length;
      const Price = Number(parseInt((this.PackageItem.Price / num) * 10));
      const Deposit = Number(parseInt((this.PackageItem.Deposit / num) * 10));
      this.memberList.forEach((res) => {
        res.Price = Number((Price / 10).toFixed(1)).toFixed(1);
        res.Deposit = Number((Deposit / 10).toFixed(1)).toFixed(1);
      });
      if (this.PackageItem.Deposit - this.sumDeposit > 0) {
        this.memberList[0].Deposit = Number(
            (
                Number(this.memberList[0].Deposit) +
                (this.PackageItem.Deposit - this.sumDeposit)
            ).toFixed(1)
        );
      }
      if (this.PackageItem.Price - this.sumPrice > 0) {
        this.memberList[0].Price = Number(
            (
                Number(this.memberList[0].Price) +
                (this.PackageItem.Price - this.sumPrice)
            ).toFixed(1)
        );
      }
    },
    deleteMember(index) {
      this.memberList.splice(index, 1);
      this.calculate(this.memberList.length);
    },
    subRent() {

      if (this.userAddress.length === 1) {
        this.$toast("当前地址暂未开通服务，请重新选择！");
        return false;
      }
      if (this.radio !== "1") {
        this.$toast("未同意宁波大学学生宿舍空调租赁协议");
        return false;
      }
      if (!this.PackageItem.Id) {
        this.$toast("请选择租赁套餐！");
        return false;
      }
      this.subRentLoading = true;
      const params = {
        DormitoryId:
            this.userAddress.length > 0
                ? this.userAddress[this.userAddress.length - 1].Id
                : this.userInfo.DormitoryId,
        PackageId: this.PackageItem.Id,
        Remarks: this.Remarks,
        IsOnline: this.payType === "onLine",
        MemberIds: this.memberList.map((item) => item.Id),
        MemberId: this.userInfo.Id,
        IsBalance: this.payType === "yue"
      };
      if (this.$route.query.type === 'change') {
        params.IsCancel = this.$route.query.IsCancel
        params.IsPay = this.$route.query.isPay
        params.OldParentOrderId = this.$route.query.OrderId
      }else {
        params.IsCancel = false
      }

      this.$post("/BizMemberParentOrder/NewAdd", params).then((res) => {
        this.subRentLoading = false;
        if (res) {
          if (res.Status !== 1) {
            this.$toast.fail(res.Message);
            return false;
          }
          this.orderId = res.Data.BizParentOrder.Id;
          this.ParentOrderId = res.Data.ParentOrderId;
          if (this.payType === "offline" || this.payType === 'yue') {
            this.$dialog.alert({
                  message: "订单已经提交成功！",
                }).then(async () => {
                  this.$router.replace({
                    path: "/userIn/orderDetails",
                    query: {Id: res.Data.BizParentOrder.Id, backUrl: 'userOrder', backQuery: JSON.stringify({ backUrl: 'home' })},
                  });
                });
          }
        }
      });
    },
    successPay(val) {
      // 支付回调
      this.$toast.loading().clear();
      this.$dialog
          .alert({
            message:
                val === "chooseWXPay:ok"
                    ? "订单支付成功！"
                    : "订单已经提交成功，请完成支付！",
          })
          .then(() => {
            this.$router.replace({
              path: "/userIn/orderDetails",
              query: {Id: this.orderId, backUrl: 'userOrder', backQuery: JSON.stringify({ backUrl: 'home' })},
            });
          });
      // this.$router.push({path: '/userIn/userOrder'})
    },
    paySuccess(id) {
      // ef123ee6-37e5-42a9-a8cb-839066cfe37b
      this.$router.push({path: "/userIn/orderDetails", query: {Id: id}});
    },
    changePackage() {
      if (this.actions.length > 0) {
        this.ShowPackage = !this.ShowPackage;
      }
    },
    onSelect(item, index) {
      this.PackageItem = item;
      // if (this.memberList.length > 0) {
      //   this.calculate(this.memberList.length, item);
      // } else {
      //   this.memberList.push({
      //     Name: this.userInfo.Name,
      //     Mobile: this.userInfo.Mobile,
      //     mobileMessage: "",
      //     Price: this.PackageItem.Price.toFixed(1),
      //     Deposit: this.PackageItem.Deposit.toFixed(1),
      //     MemberId: this.userInfo.Id,
      //     Balance: this.userInfo.Balance
      //   });
      // }
      this.getCanBalancePay()
      this.ShowPackage = false;
    },
    getPackageList() {
      // 请求套餐
      this.actions = [];
      const params = {};
      params.DormitoryId =
          this.userAddress.length > 0
              ? this.userAddress[this.userAddress.length - 1].Id
              : this.userInfo.DormitoryId; // 判断是否存在地址修改后的数组，如果有则从数组中取，如果没有，则从源数据中返回宿舍ID
      params.Type = "租赁";
      params.State = "发布";
      params.Education = this.userInfo.Education
          ? this.userInfo.Education.split("|")[0]
          : "";
      params.Grade = this.userInfo.Education
          ? this.userInfo.Education.split("|")[1]
          : "";
      this.$post("/BizMemberPackage/AllList", params).then((res) => {
        if (res.Data) {
          res.Data.forEach((item) => {
            item.name = item.Name;
          });
          this.actions = res.Data;
          if (this.$route.query.PackageId) {
            const newPackageIndex = this.actions.findIndex(cur => cur.Id === this.$route.query.PackageId)
            if (newPackageIndex > -1){
              this.onSelect(this.actions[newPackageIndex])
            }
          }

        }
      });
    },
    getUserInfo() {
      this.$post("/BizMemberMember/DetailsByKey").then(async (res) => {
        if (res) {
          if (res.Status === 1) {
            setWeixInfo(res.Data)
          }
          if (res.Data.FullAddress) {
            res.Data.FullAddress =
                res.Data.RegionName + "-" + res.Data.FullAddress;
          }
          this.userInfo = res.Data;

          this.isValidOrder = await this.getUserValidOrder(res.Data.DormitoryId)
          this.validOrderLoading = false
          if (!this.isValidOrder){
            if (res.Data.RegionId) {
              setTimeout(await this.getContract(res.Data.RegionId), 500);
            }
            if (res.Data.FullAddress) {
              await this.getPackageList();
            }
          }
        }
      });
    },
    async getUserValidOrder(DormitoryId){
      this.validOrderLoading = true
      try {
        const { Data } = await this.$post('/BizMemberParentOrder/CheckDormitoryEffectiveOrder', {DormitoryId})
        return Data
      }catch (e) {
        return ''
      }
    },
    getContract(Id, type) {
      if (type === "reload") {
        this.isReload = true;
      }
      const params = {
        Id: Id,
      };
      this.detailsLoading = true;
      this.$post("/BizMemberRegion/Details", params)
          .then((res) => {
            this.isReload = false;
            this.detailsLoading = false;
            if (res) {
              this.ContractInfo = res.Data.BizContractInfo;
            }
          })
          .catch((e) => {
            this.detailsLoading = false;
            this.detailsError = true;
            this.isReload = false;
          });
    },
    linkTo(){
      this.$router.replace({path: '/userIn/userChangeRoom', query: { backUrl: 'home' }})
    }
  },
  components: {changeAddr,dormitoryStaff},
  mounted() {
    this.getUserInfo();
  },
  activated() {
    this.getUserInfo();
  },
  destroyed() {
    this.$store.dispatch("setAddress", []); // 清空地址
  },
};
</script>

<style scoped lang="less">
.footer-btn {
  width: 100%;
  text-align: right;
  padding: 15px 20px;

  button:nth-child(1) {
    margin-right: 15px;
  }
}

.details-error {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

.members {
  background: #fff;
  margin: 10px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 10px;
}

.icon-offline,
.icon-onLine{
  font-size: 22px;
}
.icon-yuezf{
  font-size: 18px;
}
.rentStyle {
  padding-bottom: 70px;
}

.user {
  padding: 15px 17px;
  padding-bottom: 0;

  p {
    margin: 0;
    font-size: 18px;

    span {
      font-size: 14px;
      color: #999;
    }
  }
}

.pay-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;

  > div {
    margin-right: 10px;

    span {
      color: #ff6c6c;
    }
  }

  button {
    padding: 0 30px;
    background: #00d8a0 !important;
    border: 1px solid #00d8a0 !important;
  }
}

.van-cell-group {
  margin-top: 15px;
}

.FullAddress {
  &::before {
    content: "";
    left: 0;
    right: 0;
    bottom: 0;
    height: 0.053333rem;
    position: absolute;
    background: -webkit-repeating-linear-gradient(135deg,
    #ff6c6c 0,
    #ff6c6c 20%,
    transparent 0,
    transparent 25%,
    #1989fa 0,
    #1989fa 45%,
    transparent 0,
    transparent 50%);
    background: repeating-linear-gradient(-45deg,
    #ff6c6c 0,
    #ff6c6c 20%,
    transparent 0,
    transparent 25%,
    #1989fa 0,
    #1989fa 45%,
    transparent 0,
    transparent 50%);
    background-size: 2.133333rem;
  }
}

.rentStyle {
  .packageStyle {
    .van-cell__title {
      -webkit-box-flex: 0.5;
      -webkit-flex: 0.5;
      flex: 0.5;
    }

    .van-cell__value {
      -webkit-box-flex: 1.5;
      -webkit-flex: 0.5;
      flex: 1.5;
    }
  }

  textarea {
    border: 0;
  }
}
</style>
